export default __webpack_public_path__ + "static/media/control-foto1.373b1df1.jpg";